import { render, staticRenderFns } from "./UptimeReport.vue?vue&type=template&id=4b84d8fa&scoped=true&"
import script from "./UptimeReport.vue?vue&type=script&lang=js&"
export * from "./UptimeReport.vue?vue&type=script&lang=js&"
import style0 from "./UptimeReport.vue?vue&type=style&index=0&id=4b84d8fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84d8fa",
  null
  
)

export default component.exports